import { Navigate, useParams } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermission'

/**
 * RequireCapability — guard de ruta para las páginas de GESTIÓN (vista admin).
 *
 * Complementa el blindaje del backend (requirePermiso): aunque el backend ya
 * rechaza las mutaciones sin permiso, sin este guard un bombero podría montar
 * la página de gestión escribiendo la URL (y dispararía fetches que fallan).
 * Aquí lo redirigimos limpio a su destino por defecto (su dashboard o la
 * variante "self" del módulo, p.ej. /cuotas → /mis-cuotas).
 *
 * Criterio (mismo que el backend, vía usePermissions):
 *   - adminOnly → solo user.tipo === 'admin'
 *   - modulo    → admin O cargo con ese permiso ('modulo' o 'modulo.accion')
 *
 * Para cuando la sesión aún hidrata, ProtectedRoute ya bloqueó el render
 * (espera bootstrapping/loading), así que aquí user.permisos ya está disponible.
 */
export default function RequireCapability({ modulo, adminOnly = false, redirectTo = 'dashboard', children }) {
  const { can, esAdmin } = usePermissions()
  const { slug } = useParams()

  const permitido = adminOnly ? esAdmin : can(modulo)
  if (!permitido) {
    return <Navigate to={`/${slug}/${redirectTo}`} replace />
  }
  return children
}
